import React from 'react';
import { FaMapMarkerAlt, FaClock, FaPhone } from 'react-icons/fa';

const ServiceAreaPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      {/* Header */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Service Area</h1>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Door-to-door appliance service in your local area
          </p>
        </div>
      </section>

      {/* Service Area Info */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Main Card */}
            <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 mb-8">
              <div className="text-center mb-8">
                <div className="inline-block bg-blue-100 p-6 rounded-full mb-4">
                  <FaMapMarkerAlt className="text-blue-600 text-5xl" />
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  We Come to Your Doorstep
                </h2>
                <p className="text-gray-700 text-lg">
                  A.P. Cool Service provides door-to-door appliance repair and maintenance services in the local area.
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8 mt-12">
                {/* Quick Response */}
                <div className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-xl" data-testid="service-area-response">
                  <div className="flex items-start gap-4">
                    <div className="bg-blue-600 p-3 rounded-lg">
                      <FaClock className="text-white text-2xl" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Quick Response</h3>
                      <p className="text-gray-700">
                        Call us and we'll reach your location promptly. Same-day service available for urgent repairs.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Easy Booking */}
                <div className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-xl" data-testid="service-area-booking">
                  <div className="flex items-start gap-4">
                    <div className="bg-blue-600 p-3 rounded-lg">
                      <FaPhone className="text-white text-2xl" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Easy Booking</h3>
                      <p className="text-gray-700">
                        Just call or WhatsApp us with your location and appliance issue. We'll schedule a visit.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Coverage Info */}
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                Local Service Coverage
              </h3>
              
              <div className="space-y-4 text-gray-700">
                <div className="flex items-start gap-3">
                  <span className="text-2xl">✅</span>
                  <p className="flex-1">
                    <strong className="text-blue-700">Residential Areas:</strong> We serve homes and apartments in the local community.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-2xl">✅</span>
                  <p className="flex-1">
                    <strong className="text-blue-700">No Transportation Hassle:</strong> You don't need to transport heavy appliances. We come to you.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-2xl">✅</span>
                  <p className="flex-1">
                    <strong className="text-blue-700">On-Site Repair:</strong> Most repairs are completed at your location on the same visit.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-2xl">✅</span>
                  <p className="flex-1">
                    <strong className="text-blue-700">Local Technician:</strong> Sachin Paswan personally handles your service needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            How Our Service Works
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="bg-blue-600 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                1
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Call or WhatsApp</h3>
              <p className="text-gray-700">
                Contact us at +91 8655557727 or +91 7054773277 and describe your appliance issue.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-600 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                2
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">We Visit Your Home</h3>
              <p className="text-gray-700">
                Our technician will visit your location with necessary tools and parts.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-600 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                3
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Problem Solved</h3>
              <p className="text-gray-700">
                We repair your appliance on-site and ensure it's working perfectly.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Check if We Serve Your Area
          </h2>
          <p className="text-lg mb-8 text-blue-100 max-w-2xl mx-auto">
            Call us with your location and we'll let you know if we can reach you!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:8655557727"
              className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
              data-testid="service-area-cta-call"
            >
              📞 +91 8655557727
            </a>
            <a
              href="tel:7054773277"
              className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
              data-testid="service-area-cta-call-2"
            >
              📞 +91 7054773277
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceAreaPage;
